import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';
import {
  resetPasswordWithTokenDialogSetConfirmationPasswordReducerType,
  resetPasswordWithTokenDialogSetResponseStatusReducerType,
  resetPasswordWithTokenDialogSetNewPasswordReducerType,
} from './ResetPasswordWithTokenDialogConstants';

export const initialState = Map({
  responseStatus: null,
  newPassword: {
    value: '',
    isValid: true,
    errors: [],
    dirty: false,
  },
  confirmationPassword: {
    value: '',
    isValid: true,
    errors: [],
    dirty: false,
  },
});

const spec = {
  [resetPasswordWithTokenDialogSetResponseStatusReducerType]: (state, action) => {
    const { responseStatus } = action.payload;
    return state.set('responseStatus', responseStatus);
  },
  [resetPasswordWithTokenDialogSetNewPasswordReducerType]: (state, action) => {
    const { newPassword } = action.payload;
    return state.set('newPassword', newPassword);
  },
  [resetPasswordWithTokenDialogSetConfirmationPasswordReducerType]: (state, action) => {
    const { confirmationPassword } = action.payload;
    return state.set('confirmationPassword', confirmationPassword);
  },
};

export default createReducerBySpec(spec, initialState);
